module.exports = __webpack_public_path__ + "static/devices-54bb9e33162c1530913fdb735f7867fd.png";